module.exports = __webpack_public_path__ + "img/tutorial-07.a1345fae.svg";